export const KAZAPLAN_CONST = {
    KAZAPLAN_CLIENT_ID: 'Kozikaza',
    KAZAPLAN_SECRET: 'azakizok',
    KAZAPLAN_SCOPE: 'partner:users user user:wanaplans partner partner:wanaplans',
    KAZAPLAN_360_URL: 'https://viewer360.kazaplan.com',
};
